import { SearchPropertiesOptions } from "../../../types/neighborhoodSearch";
import {
  BEDS_MIN,
  BEDS_MAX,
  ACREAGE_MIN,
  ACREAGE_MAX,
  SQFT_MIN,
  SQFT_MAX,
  YEAR_BUILT_MIN,
} from "src/constants/neighborhoodSearch";
import { getMinMaxQueryParams } from "./getMinMaxQueryParams";
import { getYearBuiltMax } from "../../../utils/neighborhoodSearch";

export const getGeoSearchParams = (listOptions: SearchPropertiesOptions | null) => {
  const {
    bedrooms,
    bathrooms,
    acreage,
    squareFootage,
    yearBuilt,
    propertyType,
    companyOwned,
  } = listOptions || {};

  const bedroomsQueryParams: string[] = getMinMaxQueryParams(
    bedrooms?.[0],
    bedrooms?.[1],
    BEDS_MIN,
    BEDS_MAX
  );
  const bathroomsQueryParams: string[] = getMinMaxQueryParams(
    bathrooms?.[0],
    bathrooms?.[1]
  );
  const acreageQueryParams: string[] = getMinMaxQueryParams(
    acreage?.[0],
    acreage?.[1],
    ACREAGE_MIN,
    ACREAGE_MAX
  );
  const squareFootageQueryParams: string[] = getMinMaxQueryParams(
    squareFootage?.[0],
    squareFootage?.[1],
    SQFT_MIN,
    SQFT_MAX
  );
  const yearBuiltQueryParams: string[] = getMinMaxQueryParams(
    yearBuilt?.[0],
    yearBuilt?.[1],
    YEAR_BUILT_MIN,
    getYearBuiltMax()
  );

  return {
    bedrooms: bedroomsQueryParams,
    bathrooms: bathroomsQueryParams,
    acreage: acreageQueryParams,
    squareFootage: squareFootageQueryParams,
    yearBuilt: yearBuiltQueryParams,
    propertyType,
    companyOwned,
  };
};